module.exports = __webpack_public_path__ + "img/diw_16_DebtPay.7a07d71b.png";